(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .factory("AuthServerProvider", AuthServerProvider);

    AuthServerProvider.$inject = [
        "$http",
        "$localStorage",
        "$sessionStorage",
        "$q",
        "OrganisationTypeEnum"
    ];

    function AuthServerProvider(
        $http,
        $localStorage,
        $sessionStorage,
        $q,
        OrganisationTypeEnum
    ) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return (
                $localStorage.authenticationToken ||
                $sessionStorage.authenticationToken
            );
        }

        function login(credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe,
                skipOTP: credentials.skipOTP,
                orgType: credentials.orgType,
                captchaContent: credentials.captchaContent,
                captchaText: credentials.captchaText,
                recaptchaToken: credentials.recaptchaToken,
                sourceType: credentials.sourceType,
                source: credentials.source
            };
            //check organisation type others then, add investor in url
            if (OrganisationTypeEnum.OTHERS == credentials.orgType) {
                var url = "api/authenticate/others";
            }
            //check organisation type CLEARCORP then, add admin in url
            else if (OrganisationTypeEnum.CLEARCORP == credentials.orgType) {
                var url = "api/authenticate/admin";
            }
            return $http.post(url, data).success(authenticateSuccess);

            function authenticateSuccess(data, status, headers) {
                var bearerToken = headers("Authorization");
                if (
                    angular.isDefined(bearerToken) &&
                    bearerToken.slice(0, 7) === "Bearer "
                ) {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(
                        jwt,
                        credentials.rememberMe
                    );
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (rememberMe) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();
